<template>
  <div class="detail">
    <div class="detail-top">
      <div class="detail-top-top">
        <img class="detail-logo" :src="nodeDetail.logo">
        <div>
          <p class="detail-p1">{{nodeDetail.name}}</p>
          <p class="detail-p2" :class="{supernodeText : nodeDetail.isSuperNode,candidateText : !nodeDetail.isSuperNode}">{{nodeDetail.isSuperNode?'Supernode':'Candidate'}}</p>
        </div>
      </div>

      <div class="detail-d">
        <div class="detail-d-address">
          <p class="detail-p3">Node Address <span @click="tipDialogShow('address')" class="detail-tips">?</span></p>
          <p class="detail-p4 margintop">{{nodeDetail.address}}</p>
        </div>
        <img class="detail-btn" @click="copied" style="margin-right: -0.5rem" src="../assets/ic_copy.svg" v-clipboard:copy="nodeDetail.address || this.$route.params.id"/>
        <el-dialog
          :visible.sync="tipDialog"
          width="84%"
          center>
          <img class="dimg" src="../assets/ic_note_line.svg">
          <p class="detail-p1 dtitle">{{dialogTitle}}</p>
          <p class="detail-p4 dcontent">{{dialogContent}}</p>
        </el-dialog>

        <img class="detail-btn" src="../assets/ic_qr_code.svg" @click="codeDialog = true"/>
        <el-dialog
          :visible.sync="codeDialog"
          width="84%"
          center>
          <div class="code-top">
            <img class="detail-logo" :src="nodeDetail.logo">
            <div>
              <p class="detail-p1" style="margin-bottom: 0.05rem">{{nodeDetail.name}}</p>
              <p class="detail-p2">{{nodeDetail.address}}</p>
            </div>
          </div>
          <QRCode :msg="nodeDetail.address"/>
        </el-dialog>
      </div>
    </div>

    <div class="detail-top">
      <div class="detail-item">
        <p class="detail-p3"><strong>VSYS Staking</strong></p>
      </div>
      <div class="detail-item" style="border-top: none;">
        <p class="detail-p3">Fee</p>
        <p class="detail-p4">{{formatPercent(nodeDetail.fee,2)}}</p>
      </div>
      <div class="detail-item">
        <p class="detail-p3">Cycle</p>
        <p class="detail-p4">{{formatCycle(nodeDetail.cycle)}}</p>
      </div>
      <div class="detail-item">
        <div class="detail-p3">
          <strong>Staking2.0</strong>&emsp;
          <el-select style="max-width: 100px" v-model="value" placeholder="Select" size="small">
            <el-option
              v-for="item in nodeDetail.tokenData"
              :key="item.name"
              :label="item.name"
              :value="item.name"
              >
              <div class="flex">
                <span>{{ item.name }}</span>
                <img style="width: 20px" :src="item.logo" :alt="item.name"/>
              </div>
            </el-option>
          </el-select>
          <span style="margin-left: 8px" class="detail-tips" @click="tipDialogShow('rewards')">?</span>
        </div>
      </div>
      <div class="detail-item" style="border-top: none">
        <p class="detail-p3">Fee</p>
        <p class="detail-p4" v-if="staking(nodeDetail.tokenData).fee>0">
          {{formatPercent(staking(nodeDetail.tokenData).fee, 2)}}
        </p>
        <p class="detail-p4" v-else style="color: red">
          Not Supported
        </p>
      </div>
      <div class="detail-item">
        <p class="detail-p3">Cycle</p>
        <p class="detail-p4" v-if="staking(nodeDetail.tokenData).cycle!==''">
          {{formatCycle(staking(nodeDetail.tokenData).cycle)}}
        </p>
        <p class="detail-p4" v-else style="color: red">
          Not Supported
        </p>
      </div>
      <div class="detail-item">
        <p class="detail-p3">Capacity <span class="detail-tips" @click="tipDialogShow('capacity')">?</span></p>
        <el-popover
          placement="left"
          trigger="click"
        >
          <div class="capacity-item">
            <span class="detail-p3">Total Capacity: </span>
            <span class="detail-p4">{{nodeDetail.capacity}} VSYS</span>
          </div>
          <div class="capacity-item">
            <span class="detail-p3">Current Capacity: </span>
            <span class="detail-p4">{{nodeDetail.currentCapacity}} VSYS</span>
          </div>
          <div class="capacity-item">
            <span class="detail-p3">Current VS Total: </span>
            <span class="detail-p4">{{formatPercent(currentPercent(nodeDetail.currentCapacity,nodeDetail.capacity)/100)}}</span>
          </div>
          <el-progress :stroke-width="10" :percentage="currentPercent(nodeDetail.currentCapacity,nodeDetail.capacity)" :color="currentPercent(nodeDetail.currentCapacity,nodeDetail.capacity)==100?'#FFB637':'#49CC8B'"
                   slot="reference" :show-text="false" style="width: 0.8rem"></el-progress>
        </el-popover>
      </div>
      <div class="detail-item">
        <p class="detail-p3">Annual Return Rate</p>
        <p class="detail-p4">{{calculateReward(nodeDetail)}}</p>
      </div>
      <div class="detail-item">
        <p class="detail-p3">Efficiency <span class="detail-tips" @click="tipDialogShow('efficiency')">?</span></p>
        <p class="detail-p4">{{formatPercent(nodeDetail.efficiency,2)}}</p>
      </div>
      <div class="detail-item">
        <p class="detail-p3">Country/Area</p>
        <p class="detail-p4">{{nodeDetail.country}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { formatCycle, formatPercent } from '@/utils/data_parse';
  import QRCode from '../components/commons/QRCode';

  export default {
    name: 'NodeDetail',
    components: {
      QRCode,
    },
    data() {
      return {
        tipDialog: false,
        codeDialog: false,
        dialogTitle: '',
        dialogContent: '',
        value: 'IPX',
      };
    },
    created() {
      this.$store.dispatch('nodes/getNodeList');
    },
    computed: {
      ...mapState('nodes', {
        nodeList: 'nodeList',
        allList: 'allList',
      }),
      nodeDetail() {
        let detail = {
          id: 1,
          logo: '',
          name: '',
          fee: 0,
          address: '',
          capacity: 0,
          cycle: '',
          country: '',
          website: '',
          efficiency: 0,
          currentCapacity: 0,
          monthlyEfficiency: 0,
          roi: -1,
          isSuperNode: false,
          tokenData: [],
        };
        this.nodeList.map((item) => {
          if (item.address === this.$route.params.id) {
            detail = item;
          }
        });
        return detail;
      },
    },
    methods: {
      formatCycle,
      formatPercent,
      tipDialogShow(name) {
        if (name === 'address') {
          this.tipDialog = true;
          this.dialogTitle = 'Node Address';
          this.dialogContent = "The wallet address which supernode use to collect leasing stake. Click the address to see explorer's date on it.";
        } else if (name === 'capacity') {
          this.tipDialog = true;
          this.dialogTitle = 'Capacity';
          this.dialogContent = 'The total amount of leasing coins supernode accept. When it reachs the max capacity, supernode will stop accepting and interest sharing for new comer.';
        } else if (name === 'efficiency') {
          this.tipDialog = true;
          this.dialogTitle = 'Efficiency';
          this.dialogContent = 'The performance of block producing, strongly affect the reward.';
        } else if (name === 'rewards') {
          this.tipDialog = true;
          this.dialogTitle = '';
          this.dialogContent = 'In VSYS Staking 2.0, all VSYS staking rewards will include token on VSYS mainnet. You can see how many token you will be rewarded per day by 1 vsys on each supernode.';
        }
      },
      currentPercent(current, total) {
        if (current && total) {
          const percent = Math.min(current / total, 1) * 100;
          return percent;
        }
        if (total) {
          return 0;
        }
        return 100;
      },
      calculateReward(item) {
        let percent = 0;
        const amount = 10000;
        let amroi = 0;
        if (item.isSuperNode) {
          amroi = (amount / item.currentCapacity)
          * 60 * 36 * 24 * 365 * 1 * (1 - item.fee);
          percent = amroi / amount;
        }
        return this.formatPercent(percent, 2);
      },
      staking(data) {
        let fee = 0;
        let cycle = '';
        if (Array.isArray(data)) {
          data.map((item) => {
            if (item.name === this.value) {
              fee = item.TokenFee || 0;
              cycle = item.TokenCycle || '';
            }
          });
        }
        return { fee, cycle };
      },
      income(data) {
        const tokenData = data.tokenData;
        let tokenValue = '';
        if (tokenData && tokenData.length > 0) {
          tokenData.map((item) => {
            if (item.name === this.value) {
              tokenValue = (item.mint_amount / item.mint_day / 15 / data.currentCapacity * (1 - item.return_rate)).toFixed(8);
            }
          });
        }
        return tokenValue;
      },
      copied() {
        this.$message({
          message: 'Copied',
          type: 'success',
          customClass: 'messageMobile',
        });
      },

    },
    // mounted: function (){
    //   this.nodeList.map((item)=>{
    //     if (item.address===this.$route.params.id){
    //       this.nodeDetail = item;
    //     }
    //   })
    // }
  };
</script>

<style lang="scss">
  .detail{
    padding: 0.2rem 0.15rem;
    background: #F7F7FA;
    box-sizing: border-box;
    &-top{
      width: 3.45rem;
      border-radius: 0.06rem;
      background: white;
      padding: 0.15rem;
      box-sizing: border-box;
      margin-bottom: 0.15rem;
      &-top{
        display: flex;
        height: 0.4rem;
        align-items: center;
      }
    }
    .supernodeText{
      color: #FFAA70;
    }
    .candidateText{
      color: #7D7D80;
    }
    &-logo{
      width: 0.4rem;
      margin-right: 0.15rem;
    }
    &-p1{
      font-size: 0.18rem;
      color: #323233;
      font-family:  SFProText-medium, sans-serif;
    }
    &-p2{
      font-size: 0.12rem;
    }
    &-p3{
      font-size: 0.15rem;
      color: #7D7D80;
    }
    &-p4{
      font-size: 0.15rem;
      color: #323233;
    }
    &-d{
      margin-top: 0.15rem;
      border-top: 1px solid #F5F5F7;
      display: flex;
      justify-content: space-between;
      padding-top: 0.17rem;
      height: 0.96rem;
      box-sizing: border-box;
      &-address{
        width: 2rem;
        word-break: break-all;
      }
    }
    &-btn{
      width: 0.14rem;
      height: 0.14rem;
      cursor: pointer;
    }
    &-tips{
      color: #FF8737;
      cursor: pointer;
      border: 1px solid;
      border-radius: 50%;
      width: 0.14rem;
      height: 0.14rem;
      display: inline-block;
      line-height: 0.14rem;
      text-align: center;
      font-size: 0.14rem;
    }
    &-item{
      height: 0.5rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &-item + &-item{
      border-top: 1px solid #F5F5F7;
    }
    .el-dialog{
      border-radius: 0.08rem;
    }
    .el-dialog__header{
      padding: 0;
    }
    .el-dialog__body{
      padding: 0.3rem 0.2rem 0.4rem 0.2rem !important;
      text-align: center !important;
    }
    .el-dialog__headerbtn{
      top: 0.1rem;
      right: 0.1rem;
    }
    .el-dialog__close{
      color: #7D7D80 !important;
      font-size: 0.22rem;
    }
    .dimg{
      width: 0.56rem;
      display: block;
      margin: 0 auto;
    }
    .dtitle{
      margin-top: 0.2rem;
      margin-bottom: 0.1rem;
    }
    .dcontent{
      line-height: 0.2rem;
    }
    .code{
      &-top{
        display: flex;
        margin-bottom: 0.4rem;
        img{
          height: 0.4rem;
        }
        &>div{
          width: 1.75rem;
          text-align: left;
          word-break: break-all;
        }
      }
    }
  }
  .margintop{
    margin-top: 0.06rem;
  }
  .messageMobile{
    min-width: 0.4rem !important;
    font-size: 0.1rem;
    height: 0.2rem;
    overflow: visible !important;
    padding: 0.05rem !important;
    text-align: center;
    top: 1.7rem !important;
  }
</style>
